import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailMandantVertrag extends GuiDetailGeneric {

    constructor() {
        super("Mandant");
    }

}
